import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import { AiOutlineClose } from 'react-icons/ai';
// import CloseIcon from '@mui/icons-material/Close';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
    width:'auto',
    maxWidth:'1300px',
    overflow:'hidden'
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function DashModal(props) {
  const [open, setOpen] = React.useState(false);

    React.useEffect(()=>{
        if(props.open){
                setOpen(true);
        }
    },[props.open])

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>

      <BootstrapDialog
        onClose={()=>{handleClose(); props.handleClick('',false)}}
        aria-labelledby="customized-dialog-title"
        open={open}
        style={{height:'auto', width:'auto' }}
      >
        <DialogTitle sx={{ m: 0, p: 2, textAlign:'center', maxWidth:'1300px' }} id="customized-dialog-title">
          {props.title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={()=>{handleClose(); props.handleClick('',false)}}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <AiOutlineClose />
        </IconButton>
        <DialogContent >
          {props.content}
        </DialogContent>
          <Button autoFocus onClick={handleClose}>
            {props.button}
          </Button>
      </BootstrapDialog>
    </div>
  );
}
